// extracted by mini-css-extract-plugin
module.exports = {"pg-use-box":"dA","pgUseBox":"dA","use-card-wrap":"dB","useCardWrap":"dB","use-box-wrap":"dC","useBoxWrap":"dC"};